module.exports = __webpack_public_path__ + "static/media/tag-draft.ebf64f1b.svg";